import { Component, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { an } from 'node_modules/@fullcalendar/core/internal-common';

@Component({
  selector: 'app-group-by-options',
  standalone: false,
  templateUrl: './group-by-options.component.html',
  styleUrl: './group-by-options.component.scss'
})
export class GroupByOptionsComponent extends SubscriptionUtil implements OnInit, OnDestroy {
  translate: any;
  data:any
  // Dummy Grouping
  @Output() onGroupBySelected = new EventEmitter<string | null>();
  groupByOptions:any = [];
  groupByBacklog = [
    { label: 'Job Type', value: 'jobOrderType' },
    { label: 'Service Zone', value: 'serviceZone' }
  ];
  groupByBrythumLeft = [
     { label: 'User Group', value: 'userGroup' },
    { label: 'Service Zone', value: 'serviceZone' },
    { label: 'Designation', value: 'designation' }
  ];
  groupByBrythumRight = [
    { label: 'User Group', value: 'userGroup' },
    { label: 'Service Zone', value: 'serviceZone' },
    { label: 'Designation', value: 'designation' }
  ];
  selectedGroupBy: string | null = null;

  constructor(
    private languageTranslateService: LanguageTranslateService,
    public modalRef: BsModalRef
  ) {
    super();
  }

  ngOnInit(): void {
    console.log('GroupByOptionsComponent initialized',this.data);
    if (this.data?.groupByType === 'Backlog') {
      this.groupByOptions = this.groupByBacklog;
    }else if (this.data?.groupByType === 'BrythumLeft') {
      this.groupByOptions = this.groupByBrythumLeft;
    } else if (this.data?.groupByType === 'BrythumRight') {
      this.groupByOptions = this.groupByBrythumRight;
    }
    this.getLanguageData();
  }

  // Translation Handle

  getLanguageData() {
    this.push(this.languageTranslateService.wordSrc$.subscribe(data => {
      if (Object.keys(data).length != 0) {
        this.translate = data
      }
    }))
  }

  // Dummy Grouping handle
  onClear() {
    this.selectedGroupBy = null;
    this.onGroupBySelected.emit(null); 
    this.modalRef.hide();
  }
  onConfirm() {
    this.onGroupBySelected.emit(this.selectedGroupBy);
    this.modalRef.hide();
  }
}
